import useStatus from '@nicolaudie-group/ng-ui-kit/composables/useStatus'
import useUserStore from '@/stores/user.store'
import { toRef } from 'vue'

function useTranslationStatus() {
  const userStore = useUserStore()
  const translationStatus = toRef(userStore, 'translationStatus')
  const {
    success: translationsLoaded,
    settled: translationsSettled,
  } = useStatus(translationStatus)

  return { translationsLoaded, translationsSettled }
}

export default useTranslationStatus
